module.exports = __webpack_public_path__ + "img/020080.ad0a2d9e.png";